import React, { useState } from 'react';

import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContactSection = () => {
  
  

  return (
    <section className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0D1B2A] via-[#1a2d42] to-[#0D1B2A]">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(0deg, #C9A84C, #C9A84C 1px, transparent 1px, transparent 20px),
                           repeating-linear-gradient(90deg, #C9A84C, #C9A84C 1px, transparent 1px, transparent 20px)`
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-playfair font-bold text-[#C9A84C] mb-4">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C] mx-auto mb-6"></div>
          <p className="text-gray-300 font-dmsans max-w-3xl mx-auto">
            Reach out to us for professional assistance. We have offices in Jaipur, India and Dubai, UAE.
          </p>
        </div>

        {/* Office Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* India Office */}
          <div className="bg-[#FAF8F3] p-8 rounded-lg shadow-lg border-t-4 border-[#C9A84C]">
            <h3 className="text-2xl font-playfair font-bold text-[#0D1B2A] mb-6">
              India Head Office
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p className="font-semibold text-[#0D1B2A]">AGDG & Associates, Chartered Accountants</p>
                  <p>R-8A, 2nd Floor, Yudhishthir Marg</p>
                  <p>C-Scheme, Jaipur – 302006</p>
                  <p>Rajasthan, India</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Phone className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p>+91-9799494481</p>
                  <p>+91-9314922355</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p>auditors@agdgassociates.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Clock className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p>Monday – Saturday</p>
                  <p>10:00 AM – 6:30 PM IST</p>
                </div>
              </div>
            </div>
          </div>

          {/* Dubai Office */}
          <div className="bg-[#FAF8F3] p-8 rounded-lg shadow-lg border-t-4 border-[#C9A84C]">
            <h3 className="text-2xl font-playfair font-bold text-[#0D1B2A] mb-6">
              International Branch (Dubai, UAE)
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p className="font-semibold text-white">AGDG & Associates</p>
                  <p>Villa 4, 352/27 Umm Sqim</p>
                  <p>Premise No. 352991356</p>
                  <p>PO Box 24589, Dubai</p>
                  <p>United Arab Emirates</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail className="text-[#C9A84C] flex-shrink-0 mt-1" size={24} />
                <div className="font-dmsans text-gray-700">
                  <p>auditors@agdgassociates.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Google Map */}
        <div className="mb-16">
          <h3 className="text-2xl font-playfair font-bold text-[#0D1B2A] mb-6 text-center">
            Locate Our Jaipur Office
          </h3>
          <div className="w-full h-96 rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.8285468384766!2d75.79160631504413!3d26.917204883138873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db41ec21c17a5%3A0x7df0a0b0a0b0a0b0!2sYudhishthir%20Marg%2C%20C%20Scheme%2C%20Ashok%20Nagar%2C%20Jaipur%2C%20Rajasthan%20302001!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="AGDG & Associates Jaipur Office Location"
            ></iframe>
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default ContactSection;
